// src/redux/slices/sliderSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchSliders = createAsyncThunk("slider/fetchSliders", async () => {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const response = await axios.get(`${baseURL}/home/sliders`);
  return response.data.data;
});

const sliderSlice = createSlice({
  name: "slider",
  initialState: {
    sliders: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSliders.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchSliders.fulfilled, (state, action) => {
        state.isLoading = false;
        state.sliders = action.payload;
      })
      .addCase(fetchSliders.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export default sliderSlice.reducer;
